import { Editor } from 'grapesjs';

export const pasteTextOnly = (editor: Editor) => {
  // Флаг, указывающий, что обработчик уже добавлен
  let handlerAdded = false;

  // Добавляем обработчик paste только один раз при инициализации плагина
  const addPasteHandler = () => {
    if (handlerAdded) {
      return;
    }

    const iframeBody = editor.Canvas.getBody();

    iframeBody.addEventListener(
      'paste',
      function (e) {
        // Проверяем, произошло ли событие в contenteditable элементе
        let target: HTMLElement | null = e.target as HTMLElement;
        let isContentEditable = false;

        // Проверяем цепочку элементов до нахождения contenteditable
        while (target && target !== iframeBody) {
          if (target.getAttribute('contenteditable') === 'true') {
            isContentEditable = true;
            break;
          }
          target = target.parentElement;
        }

        // Если элемент contenteditable, обрабатываем вставку
        if (isContentEditable && !!target) {
          e.preventDefault();
          const rawText = e.clipboardData?.getData('text/plain');
          // Удаляем нежелательные символы разрыва строк/параграфов
          const cleanText = rawText ? rawText.replace(/\u2028|\u2029/g, '') : '';
          target.ownerDocument.execCommand('insertText', false, cleanText);
        }
      },
      true,
    );

    // Отмечаем, что обработчик добавлен
    handlerAdded = true;
  };

  // Добавляем обработчик сразу при загрузке редактора
  editor.on('load', () => {
    addPasteHandler();
  });
};
